import api from './api';

const adminContentCardsService = {
  // Get all content cards with filtering
  getAll: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `/admin/content-cards${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data;
  },

  // Get single content card by ID
  getById: async (id) => {
    const response = await api.get(`/admin/content-cards/${id}`);
    return response.data;
  },

  // Create new content card
  create: async (cardData) => {
    const response = await api.post('/admin/content-cards', cardData);
    return response.data;
  },

  // Update existing content card
  update: async (id, cardData) => {
    const response = await api.put(`/admin/content-cards/${id}`, cardData);
    return response.data;
  },

  // Delete content card
  delete: async (id) => {
    const response = await api.delete(`/admin/content-cards/${id}`);
    return response.data;
  },

  // Get all categories
  getCategories: async () => {
    const response = await api.get('/admin/content-cards/categories/all');
    return response.data;
  },

  // Get all suppliers
  getSuppliers: async () => {
    const response = await api.get('/admin/content-cards/suppliers/all');
    return response.data;
  },

  // Upload image for content card
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    
    const response = await api.post('/admin/content-cards/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }
};

export default adminContentCardsService;
